import { Form, Spin } from "antd";
import FormItem from "antd/lib/form/FormItem";
import Select, { SelectValue } from "antd/lib/select";
import * as MovieApi from "movieapi";
import * as React from "react";
import AuthService from "src/helpers/AuthService";
import { IChooseMovieProps } from "./ChooseMovie";

export interface IMovieAutoCompleteState {
  titleResults: MovieApi.MovieTitleAutocompleteOut[];
  loading: boolean;
}

const initialState: IMovieAutoCompleteState = {
  loading: false,
  titleResults: []
};

export default class MovieAutoComplete extends React.Component<
  IChooseMovieProps,
  IMovieAutoCompleteState
> {
  constructor(props: IChooseMovieProps) {
    super(props);

    this.state = initialState;
    this.handleTitleSearch = this.handleTitleSearch.bind(this);
    this.handleTitleSelect = this.handleTitleSelect.bind(this);
  }

  public render() {
    // the layout for the form, labels are aligned left then right on
    // large screens and are stacked vertically on small screens
    const formItemLayout = {
      labelCol: {
        sm: { span: 8 },
        xs: { span: 24 }
      },
      wrapperCol: {
        sm: { span: 16 },
        xs: { span: 24 }
      }
    };

    // autocomplete options for the movie_title
    const titleChildren = this.state.titleResults.map(result => {
      return (
        <Select.Option key={result.movie_id.toString()}>
          {result.movie_title}
        </Select.Option>
      );
    });

    return (
      <Form>
        <FormItem {...formItemLayout} label="Movie Title">
          <Spin spinning={this.state.loading}>
            <Select
              defaultValue={this.props.data.movie_title}
              showSearch={true}
              filterOption={false}
              allowClear={true}
              onSearch={this.handleTitleSearch}
              onSelect={this.handleTitleSelect}
              placeholder="enter movie title"
              defaultActiveFirstOption={false}
            >
              {titleChildren}
            </Select>
          </Spin>
        </FormItem>
      </Form>
    );
  }

  private handleTitleSearch(value: string): void {
    if (!value) {
      this.setState({ titleResults: [] });
    } else {
      const api = new MovieApi.AutocompleteApi(
        new AuthService().getConfiguration(),
        process.env.REACT_APP_BASE_URL
      );
      api
        .getAutoCompleteResultsForAMovieTitle({ text: value })
        .then(result => this.setState({ titleResults: result }));
    }
  }

  private handleTitleSelect(value: SelectValue, option: JSX.Element) {
    const movieId = Number(option.key);
    if (!movieId || Number.isNaN(movieId)) {
      return;
    } else {
      this.setState({ loading: true });
      const api = new MovieApi.InfoApi(
        new AuthService().getConfiguration(),
        process.env.REACT_APP_BASE_URL
      );
      api.getInformationAboutAMovie({ movie_id: movieId }).then(result => {
        this.setState({ loading: false });
        this.props.handleMovieChange(result);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/MovieAutocomplete.tsx